import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { FileDown, Loader2 } from 'lucide-react';

/**
 * Health PDF export card (weekly + monthly).
 * Extracted from Settings.jsx (line 1109-1185).
 */
export function DataExportCard({ language, exportingPDF, onExportPDF }) {
    const isDe = language === 'de';
    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                    <FileDown className="w-5 h-5 text-cyan-500" />
                    {isDe ? 'Daten exportieren' : 'Export Data'}
                </CardTitle>
                <CardDescription>
                    {isDe
                        ? 'Exportiere deine Gesundheitsdaten als PDF für Ärzte oder Coaches'
                        : 'Export your health data as PDF for doctors or coaches'}
                </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <ExportRow
                    bg="bg-cyan-50 dark:bg-cyan-950/30"
                    title={isDe ? '📅 Wochenbericht (7 Tage)' : '📅 Weekly Report (7 days)'}
                    subtitle={isDe ? 'Fitness, Schlaf, Ernährung, Stimmung, Symptome' : 'Fitness, sleep, nutrition, mood, symptoms'}
                    loading={exportingPDF === 'week'}
                    disabled={!!exportingPDF}
                    onClick={() => onExportPDF('week')}
                    testId="export-weekly-pdf-btn"
                />
                <ExportRow
                    bg="bg-violet-50 dark:bg-violet-950/30"
                    title={isDe ? '📆 Monatsbericht (30 Tage)' : '📆 Monthly Report (30 days)'}
                    subtitle={isDe ? 'Ideal für Arztbesuche und Langzeitanalyse' : 'Ideal for doctor visits and long-term analysis'}
                    loading={exportingPDF === 'month'}
                    disabled={!!exportingPDF}
                    onClick={() => onExportPDF('month')}
                    testId="export-monthly-pdf-btn"
                />
                <p className="text-xs text-muted-foreground text-center pt-2">
                    {isDe
                        ? '🐺 Enthält: Statistiken, Stimmungsverlauf, Symptome & Nanouks Analyse'
                        : '🐺 Includes: Statistics, mood history, symptoms & Nanouk\'s analysis'}
                </p>
            </CardContent>
        </Card>
    );
}

function ExportRow({ bg, title, subtitle, loading, disabled, onClick, testId }) {
    return (
        <div className={`flex items-center justify-between p-3 rounded-lg ${bg}`}>
            <div>
                <p className="font-medium">{title}</p>
                <p className="text-sm text-muted-foreground">{subtitle}</p>
            </div>
            <Button
                onClick={onClick}
                disabled={disabled}
                variant="outline"
                className="gap-2"
                data-testid={testId}
            >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
                PDF
            </Button>
        </div>
    );
}
